import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { gql } from "types";

export const CONTINUE_TIMER_NODE = gql(/* GraphQL */ `
  mutation ContinueTimerNode($runId: String!, $nodeKey: String!) {
    continueTimerNode(runId: $runId, nodeKey: $nodeKey) {
      id
      status
    }
  }
`);

/**
 * Fires the `continueTimerNode` support-tool mutation, which skips a pending
 * timer node's remaining wait and continues the workflow to the next node.
 * Side effects (toasts, refetch) are left to the caller.
 */
export const useContinueTimer = () => {
  const [continueTimerNode, { loading }] = useMutation(CONTINUE_TIMER_NODE);

  const continueTimer = useCallback(
    (runId: string, nodeKey: string) =>
      continueTimerNode({ variables: { runId, nodeKey } }),
    [continueTimerNode],
  );

  return { continueTimer, loading };
};
